import React from 'react'

import { BodyText, Label, KlarnaIcon } from '@pb/components'
import { OptimizelyFeature } from '@optimizely/react-sdk'

import OPTIMIZELY from 'constants/optimizely'
import { PAYMENT_MODES } from 'features/cart/constants'

const KlarnaGDPRPolicy: React.FC<any> = ({ paymentCode }) => {
  const isPayLater = [
    PAYMENT_MODES.PAY_LATER,
    PAYMENT_MODES.PAY_OVER_TIME,
    PAYMENT_MODES.PAY_IN_PARTS,
  ].includes(paymentCode)

  if (!isPayLater) {
    return null
  }

  return (
    <>
      <OptimizelyFeature feature={OPTIMIZELY.KLARNA_PAY_LATER}>
        {(enabled) => {
          return enabled ? (
            <BodyText Tag="p">
              <Label copyKey="checkout.omnicredit.information1" />
            </BodyText>
          ) : null
        }}
      </OptimizelyFeature>
      <BodyText Tag="p">
        <Label copyKey="checkout.omnicredit.informations" />
      </BodyText>
      <KlarnaIcon />
    </>
  )
}

export default KlarnaGDPRPolicy
